module.exports = __webpack_public_path__ + "media/images/emblems/Obersimmental-coat_of_arms-8fdb849c15e0357bf2064b1200350ae9.svg";